// Module
var code = "<div class=\"loading-tracker\" data-ng-show=\"tracker.active()\"> <div class=\"page-loading-icon\"></div> </div> <div class=\"animate-show\" data-ng-transclude data-ng-show=\"!tracker.active()\"></div> ";
// Exports
module.exports = code;